var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showBox)?_c('BoxModel',{staticClass:"iv-onelevel-content-wrapper iv-cover-input"},[_vm._t("default")],2):_vm._e()],1)}
var staticRenderFns = []
export { render, staticRenderFns }